<template>
  <div class="footer">
    <div class="footer__warp">
      <div>
        友情链接：
        <a target="_blank" href="https://www.nmpa.gov.cn/">国家药监局 ｜</a>
        <a target="_blank" href="http://www.nhc.gov.cn/">国家卫计委 ｜</a>
        <a target="_blank" href="http://www.cpl.org.cn">中物联医药流通分会 ｜</a>
        <a target="_blank" href="http://www.sinopharm.com/56.html">中国医药集团</a>
      </div>
      <div>
        <a
          target="_blank"
          href="https://91jkys-static.oss-cn-hangzhou.aliyuncs.com/upload/202308/03/康明网络食品销售第三方平台备案.jpg"
        >
          网络食品销售第三方平台备案 ｜
        </a>
        <a target="_blank" href="https://kit-static.91jkys.com/attachment/kit-server/d70be9e2b6bd42e69aa4bb256cf1aabe5254d717cdb89248535525f1d2eac3e4.png">营业执照 ｜</a>
        <a target="_blank" :href="cert1">医疗器械第三方平台备案凭证 ｜</a>
        <a target="_blank" href="https://kit-static.91jkys.com/attachment/kit-server/e0658bfba6ce4ad5874d7cd3f0f6742402325e13e734ae56f1868e6c6b584d89.pdf">ICP经营许可证 ｜</a>
        <a target="_blank" :href="cert2">互联网药品信息服务资格证书 ｜</a>
        <a target="_blank" :href="cert3">药品网络交易第三方平台备案</a>
        <!--        <a target="_blank" :href="file1">食品经营许可证</a>-->
        <!--        <a target="_blank" :href="file2">营业执照</a>-->
        <!--        <a target="_blank" :href="file1">医疗器械第三方平台备案凭证</a>-->
        <!--        <a target="_blank" :href="file1">ICP经营许可证</a>-->
        <!--        <a target="_blank" :href="file1">互联网药品信息服务资格证书</a>-->
      </div>
      <div class="line">
        杭州康明信息技术有限公司 ｜ 浙ICP备2021004431号-2 ｜ 经营许可证编号：浙B2-20210258 ｜
        互联网信息服务资格证号：浙网药信备字（2026）00097号
      </div>
      <div>Copyright©2023 All Rights Reserved Hangzhou Kang Ming Information Technology Co., Ltd.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainFooter',
  data() {
    return {
      file1: 'https://91jkys-static-b2b-admin.oss-cn-hangzhou.aliyuncs.com/fe_static_file1',
      file2: 'https://91jkys-static-b2b-admin.oss-cn-hangzhou.aliyuncs.com/fe_static',
      cert1: 'https://kit-static.91jkys.com/attachment/kit-server/369fe723cd874612960fde41c78b7acf122ec10f6ef2f39f9a728f61944dcdd3.pdf',
      cert2: 'https://kit-static.91jkys.com/attachment/kit-server/82f77b3ebb7b454e8074fcabda69508d937b104346a747c9b2e9f91ed6b4c7e1.png',
      cert3: require('@/assets/cert/certificate3.jpg')
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.footer {
  text-align: center;

  height: auto;
  .footer__warp {
    max-width: 1440px - 191px - 191px;
    margin: 0 auto;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #595959;
    line-height: 24px;
    a {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #595959;
      line-height: 24px;
      //margin-right: 12px;
    }
    .line {
      white-space: nowrap;
    }
    // text-align: center;
  }
}
</style>
